
import { callApi } from "utils/api";
import crud from "./_crud";

const actions = crud('super_admin_billing', 'la facturación de socios', 'las facturaciones de socios');

const getSuperAdminBillingsByPeriod = (period) => {
    return async (dispatch, getState) => {
        const state = getState();

        const res = await callApi(`/super_admin_billing/get_super_admin_billings_by_period/${period}`, {
            method: 'GET',
            headers: {
                token: state.app.superAdmin.token
            }
        })

        return res.body;
    }
}

const getSuperAdminBillingIndividual = (super_admin_id) => {
    return async (dispatch, getState) => {
        const state = getState();

        const res = await callApi(`/super_admin_billing/get_super_admin_billing_individual/${super_admin_id}`, {
            method: 'GET',
            headers: {
                token: state.app.superAdmin.token
            }
        })

        return res.body;
    }
}

const getSuperAdminBillingByPeriod = (super_admin_id, period) => {
    return async (dispatch, getState) => {
        const state = getState();

        const res = await callApi(`/super_admin_billing/get_super_admin_billing_by_period/${super_admin_id}/${period}`, {
            method: 'GET',
            headers: {
                token: state.app.superAdmin.token
            }
        })

        return res.body;
    }
}

export default {
    ...actions,
    getSuperAdminBillingsByPeriod,
    getSuperAdminBillingIndividual,
    getSuperAdminBillingByPeriod
}